<template>
    <div class="ur-data-grid__info-item">
        <span class="ur-data-grid__info__total" v-html="totalCountMsg"/>
    </div>
</template>

<script>
export default {
    name : 'urDataGridInfoModuleTotalCnt',
    inject:['gridInfo'],
    computed:{
        totalCountMsg(ij) {
            const GRID_INFO = this.gridInfo;
            let msg = GRID_INFO.opts.msgTotal.replace("<","&lt;");
            return msg.replace("#","<b>"+GRID_INFO.vars_dataSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')+"</b>");
        }
    }
    
}
</script>